﻿(function (angular) {
    'use strict';

    angular.module('Toyota.Directives')
        .directive('tyValidRego', function Map() {
            return {
                require: 'ngModel',
                link: function (scope, elm, attrs, ctrl) {
                    ctrl.$validators.regoRegex = function (modelValue) {
                        if (ctrl.$isEmpty(modelValue)) {
                            // consider empty model valid
                            return true;
                        }
                        return /^[A-Za-z0-9]{1,9}$/.test(modelValue);
                    };
                    ctrl.$validators.regoApiHasRunAndValueIsValid = function (modelValue) {
                        if (ctrl.$name !== "registrationMainForm" && scope.hasCheckedRego) {
                            return scope.isRegoValidatedByApi;
                        }
                        return true;
                   };
                }
            };
        });
})(window.angular);